export const CoreUsersByIdNotificationPreferencesName = 'CoreUsersByIdNotificationPreferences';
